// Login keys layout view
import _ from 'underscore';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import AlertMixin from '@/mixins/alert';
import LoginKeyItemView from '@/views/login_key';
import template from '@/../templates/login-keys-layout.hbs';
import Button from '@/views/button';


    var globalCh = Radio.channel('global');
    var alertCh = Radio.channel('alerts');

    var MAX_LOGIN_KEYS = 10; // Max allowed per account
    var empty_tmpl = '<p class="primary">There are no login keys for this account</p>'
        + '<p><a title="Create a new login key">Create</a> a new login key</p>';
    var EmptyView = Marionette.View.extend({
        template: Handlebars.compile(empty_tmpl)
    });

    function create_login_keys_list_view(parent) {
        return new Marionette.CollectionView({
            tagName: 'ul',
            ui: {
                toggle: '[data-toggle="collapse"]',
            },
            events: {
                'show.bs.collapse': function(e) {
                    $(e.target.previousElementSibling).find(".caret-toggle").toggleClass("fa-rotate-90");
                },
                'hide.bs.collapse': function(e) {
                    $(e.target.previousElementSibling).find(".caret-toggle").toggleClass("fa-rotate-90");
                }
            },
            title: 'Login Keys',
            collection: parent.collection,
            childView: LoginKeyItemView,
            collectionEvents: {
                'change': 'render'
            },
            emptyView: EmptyView,
            emptyViewOptions: {
                className: 'no-products',
                collection: parent.collection,
                template: Handlebars.compile(empty_tmpl),
                ui: {
                    link: 'a'
                },
                events: {
                    'click @ui.link': function (e) {
                        e.preventDefault();
                        var options = {
                            success: function (model, sent_values) {
                                var message = 'Login key generated successfully';
                                alertCh.request('showAlert', {
                                    message: message,
                                    messageType: 'success',
                                    timeout: 5000
                                });
                            }
                        };
                        globalCh.request('show_create_login_keys_dialog', parent.model, options);
                    }
                },
            }
        });
    }
    
    var LoginKeysView = Marionette.View.extend(AlertMixin).extend({
        className: 'standard-layout',
        id: 'login-keys',
        ui: {
            alerts: '.alerts',
            create_item: '.create-item-region',
            login_keys_region: '.login-keys-region'
        },
        regions: {
            alerts: '@ui.alerts',
            create_item: '@ui.create_item',
            login_keys_region: '@ui.login_keys_region'
        },
        initialize: function () {
            globalCh.reply('layout_alert', this.alert.bind(this));
        },
        templateContext: function () {
            return {
                title: this.getOption('title') || 'Untitled',
            };
        },
        template: Handlebars.compile(template),
        collectionEvents: {
            'update': 'validate_create',
        },
        childViewEvents: {
            'alert': 'child_alert',
        },
        onRender: function () {
            // Passing in this as the empty view needs elements from it
            var login_keys_list_view = create_login_keys_list_view(this);
            this.showChildView('login_keys_region', login_keys_list_view);

            this.showChildView('create_item', new Button({
                className: 'btn btn-primary',
                text: 'Create Login Key',
                icon: 'fa fa-plus-circle',
                action: _.bind(this.show_add_dialog, this)
            }));
        },
        child_alert: function (message, type, timeout) {
            this.alert(message, type, timeout);
        },
        validate_create: function() {
            if (this.collection.length >= MAX_LOGIN_KEYS) {
                this.ui.create_item.find('button').attr('disabled', true);
                this.ui.create_item.find('button').css('cursor', 'not-allowed');
                this.getRegion('create_item').currentView.set_tooltip_title('A maximum of 10 login keys are allowed');
            } else {
                this.ui.create_item.find('button').attr('disabled', false);
            }
        },
        show_add_dialog: function () {
            var options = {
                success: function (model, sent_values) {
                    var message = 'Login key generated successfully';
                    alertCh.request('showAlert', {
                        message: message,
                        messageType: 'success',
                        timeout: 5000
                    });
                }
            };
            globalCh.request('show_create_login_keys_dialog', this.model, options);
        },
    });

    export default LoginKeysView;
    

